export default "__VITE_ASSET__CjHbsxq4__"